import { createResponsesImage } from '../createResponsesImage/createResponsesImage';
import component from './ResponsesImage500Svg';

export const ResponsesImage500 = createResponsesImage({
  name: 'ResponsesImage500',
  component,
});
